import { instance, GETREQUESTOPTIONS } from '../../apiService';

const API_URL = '/api/cpt-analytics/config';

export interface CPTCodeConfigValue {
    cptCode: string;
    rvuPerUnit: number;
    reimbursementPerUnit: number;
}

export interface CPTConfigValue {
    departmentId: string;
    monthlyRvuTarget: number;
    monthlyRevenueTarget: number;
    cptCodeConfigs: CPTCodeConfigValue[];
    updatedBy?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface UpdateCPTConfigInput {
    monthlyRvuTarget: number;
    monthlyRevenueTarget: number;
    cptCodeConfigs: Array<{
        cptCode: string;
        rvuPerUnit: number;
        reimbursementPerUnit: number;
    }>;
}

const getCPTConfig = async (): Promise<CPTConfigValue> => {
    const response = await instance.get(API_URL, GETREQUESTOPTIONS());
    return response.data;
};

const updateCPTConfig = async (
    payload: UpdateCPTConfigInput
): Promise<CPTConfigValue> => {
    const response = await instance.put(
        API_URL,
        payload,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

const cptConfigService = {
    getCPTConfig,
    updateCPTConfig,
};

export default cptConfigService;
